<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import AvailableTaxRates from './AvailableTaxRates/index.vue'
import BasicInforMation from './BasicInforMation/index.vue'
import riskInformation from './riskInformation/index.vue'
export default {
	components:{
		AvailableTaxRates,
		BasicInforMation,
		riskInformation
	},
	data() {
		return {
			activeName:"BasicInforMation"
		};
	},
	mounted() {
	
	},
	created() {},
	methods: {
		forRouter(){
		
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
